import { useQuery } from "@tanstack/react-query";
import { dashboardService } from "../api/services/dashboardService";
import {
  DashboardData,
  SuperAdminDashboardData,
} from "../schemas/dashboardSchema";
import { isSuperAdmin } from "../utils/navigationUtils";

export const useDashboard = (userRole?: string) => {
  const isSuperAdminUser = isSuperAdmin(userRole);

  const {
    data: dashboardData,
    isLoading: isDashboardLoading,
    refetch,
  } = useQuery<DashboardData, Error>({
    queryKey: ["dashboard"],
    queryFn: () => dashboardService.getActiveScreensDashboard(),
    enabled: !isSuperAdminUser,
  });

  const {
    data: superAdminDashboardData,
    isLoading: isSuperAdminDashboardLoading,
    refetch: refetchSuperAdmin,
  } = useQuery<SuperAdminDashboardData, Error>({
    queryKey: ["superAdminDashboard"],
    queryFn: () => dashboardService.getSuperAdminDashboard(),
    enabled: isSuperAdminUser,
  });

  return {
    dashboardData,
    superAdminDashboardData,
    isLoading: isSuperAdminUser
      ? isSuperAdminDashboardLoading
      : isDashboardLoading,
    isSuperAdmin: isSuperAdminUser,
    refetchDashboard: isSuperAdminUser ? refetchSuperAdmin : refetch,
  };
};
